import { render } from "./BoxPage.vue?vue&type=template&id=49e863cc&ts=true"
import script from "./BoxPage.vue?vue&type=script&lang=ts"
export * from "./BoxPage.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__